var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"zoox-component zoox-tab-menu",style:({
    'grid-template-columns': `repeat(${_vm.menuOptions.length}, minmax(50px, 1fr))`,
    absolute: _vm.absolute,
  })},_vm._l((_vm.menuOptions),function(option,index){return _c('div',{key:index,staticClass:"menu-option",on:{"click":function($event){return _vm.onClickOption(option)}}},[_c('z-icon',{staticClass:"icon",class:{'is-active': option.isActive},attrs:{"size":"24px","color":"var(--white)"}},[_vm._v(_vm._s(option.icon))]),_c('div',{staticClass:"menu-option-title"},[_vm._v(" "+_vm._s(option.title)+" ")])],1)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }